import { Component } from '@angular/core';

/**
 * Demonstrate the usage of {@link TableComponent}
 */
@Component({
  templateUrl: './tablesaw-demo.component.html',
  styleUrls: ['./tablesaw-demo.component.scss'],
})
export class TablesawDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/table/tablesaw/tablesaw-demo.component.ts